(() => {
  const header = $("[data-sticked-header]");
  const searchInput = $(".c-search-form__input");
  const navigation = $(".c-main-navigation");
  //const logo = $(".c-site-header__logo");
  const docScroll = $(window);
  let top = $(window).scrollTop();
  const ACTIVE_CLASS = {
    header: "c-site-header--sticked",
    input: "c-search-form__input--sticked",
    navigation: "c-main-navigation--sticked"
  };
  // const changeLogo = () => {
  //   if (!header.hasClass("c-site-header--no-bg")) {
  //     if (header.hasClass("c-site-header--sticked")) {
  //       logo.attr(
  //         "src",
  //         "/wp-content/themes/selena-tytan.com/dist/images/tytan-logo.svg"
  //       );
  //     } else {
  //       logo.attr(
  //         "src",
  //         "/wp-content/themes/selena-tytan.com/dist/images/logo-white.svg"
  //       );
  //     }
  //   }
  // };
  const addSticky = () => {
    header.addClass(ACTIVE_CLASS.header);
    searchInput.addClass(ACTIVE_CLASS.input);
    navigation.addClass(ACTIVE_CLASS.navigation);
    //changeLogo();
  };

  const removeSticky = () => {
    header.removeClass(ACTIVE_CLASS.header);
    searchInput.removeClass(ACTIVE_CLASS.input);
    navigation.removeClass(ACTIVE_CLASS.navigation);
    //changeLogo();
  };

  const initSticky = () => {
    if (top > 0) {
      addSticky();
    } else {
      removeSticky();
    }
  };

  const toggleStickyClass = event => {
    const scrollPosition = $(event.target).scrollTop();

    if (scrollPosition > 0) {
      addSticky();
    } else {
      removeSticky();
    }
  };

  docScroll.on("scroll", toggleStickyClass);
  initSticky();
})();
